export enum BillingCycleEnum {
  Yearly = 'YEARLY',
  Monthly = 'MONTHLY',
}